import React from 'react'
import { connect } from 'react-redux'
import Snackbar from 'react-md/lib/Snackbars';

import { actions } from './notificationHandlerRedux'
import './NotificationHandler.css'

const NotificationHandler = ({ infoToasts, errorToasts, autohideToasts, dismissInfoToast, dismissErrorToast }) => (
	<div className="notification-container">
		<Snackbar
			className="notification-container--info-toasts"
			id="info-toasts"
			toasts={infoToasts}
			autohide={autohideToasts}
			onDismiss={dismissInfoToast}
		/>
		<Snackbar
			className="notification-container--error-toasts"
			id="error-toasts"
			autohideTimeout={5000}
			toasts={errorToasts}
			autohide={autohideToasts}
			onDismiss={dismissErrorToast}
		/>
	</div>
);

const mapStateToProps = ({ notificationHandler }) => ({
	infoToasts: notificationHandler.infoToasts,
	errorToasts: notificationHandler.errorToasts,
	autohideToasts: notificationHandler.autohideToasts
});

export default connect(mapStateToProps, actions)(NotificationHandler);


// WEBPACK FOOTER //
// ./src/components/handlers/notification/NotificationHandler.jsx